import { Modal } from 'react-bootstrap';

const cookieModalHtml = `
<div class="ques addSpace">
  <p>
    Pursuant to Article 13 of the EU Regulation 2016/679 (hereinafter the "Regulation"), Centrico S.p.A. (hereinafter
    the "Company" and/or the "Data Controller"), provides you with the following information regarding the
    characteristics of the processing it carries out on your personal data.
  </p>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">1)</span> Who is the Data Controller of your personal data?</h6>
  <p>
    The Data Controller of your personal data is Centrico S.p.A. with headquarters at Piazza Gaudenzio Sella,
    No. 1, 13900, Biella.
  </p>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">2)</span> How to contact the Data Protection Officer?</h6>
  <p>The Data Protection Officer ("DPO") can be contacted at the following addresses:</p>
  <ul style="list-style-type: none;">
    <li><span aria-hidden="true">-</span> postal address: Piazza Gaudenzio Sella 1, Biella</li>
    <li><span aria-hidden="true">-</span> e-mail address: <a href="mailto:dpo@sella.it">dpo@sella.it</a></li>
  </ul>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">3)</span> What are the types of cookies processed? On what legal basis and for what purposes
    does the Company process them?
  </h6>
  <p class="addLessSpace">
    A cookie is a small piece of data (text file) that a website, when visited by a user, asks the browser
    to store on the device to remember his or her information, such as preferred language or login information.
    These cookies are set by the Company and referred to as first-party cookies. The Company also uses third-party
    cookies, i.e., cookies from a domain other than the website you are visiting.
  </p>
  <p class="addLessSpace">
    You can view more details regarding the first- and third-party cookies used by the website in the
    "Change Preferences" section of the banner present when you first log in or at any time thereafter by logging
    into the "Privacy" section of the website.
  </p>
  <p class="addSpace">
    The details of the categories of cookies used by this website are represented below.
  </p>
  <p style="font-weight: bold;">Technical (strictly necessary) cookies</p>
  <p>
    Technical or necessary cookies are used for the sole purpose of making it possible for you to navigate the
    website and enable you to use its features; therefore, their use is necessary and does not require your consent.
  </p>
  <table id="privacy-table" class="mb-3">
    <thead>
      <tr>
        <th scope="col">Cookie Subgroup</th>
        <th scope="col">Cookie</th>
        <th scope="col">Cookie used</th>
        <th scope="col">Duration</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/_ga">_ga</a></td>
        <td>First party</td>
        <td>730 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/_gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx">_gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx</a></td>
        <td>First party</td>
        <td>0 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/_gat_UA-">_gat_UA-</a></td>
        <td>First party</td>
        <td>0 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/_gid">_gid</a></td>
        <td>First party</td>
        <td>1 day</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/eupubconsent">eupubconsent</a></td>
        <td>First party</td>
        <td>2914153 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/OptanonAlertBox">OptanonAlertBox</a></td>
        <td>First party</td>
        <td>365 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/OptanonConsent">OptanonConsent</a></td>
        <td>First party</td>
        <td>365 days</td>
      </tr>
      <tr>
        <td>centrico.tech</td>
        <td><a href="https://cookiepedia.co.uk/cookies/JSESSIONID">JSESSIONID</a></td>
        <td>First party</td>
        <td>Session</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/codepen.io">codepen.io</a></td>
        <td>__cf_bm</td>
        <td>Third party</td>
        <td>0 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/codepen.io">codepen.io</a></td>
        <td>__cfduid</td>
        <td>Third party</td>
        <td>30 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/codepen.io">codepen.io</a></td>
        <td>__cfruid</td>
        <td>Third party</td>
        <td>Session</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/bootstrapcdn.com">bootstrapcdn.com</a></td>
        <td>__cfduid</td>
        <td>Third party</td>
        <td>30 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/cookielaw.org">cookielaw.org</a></td>
        <td>__cfduid</td>
        <td>Third party</td>
        <td>30 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/medium.com">medium.com</a></td>
        <td>__cfduid</td>
        <td>Third party</td>
        <td>30 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/medium.com">medium.com</a></td>
        <td>__cfrduid</td>
        <td>Third party</td>
        <td>Session</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/medium.com">medium.com</a></td>
        <td>uid</td>
        <td>Third party</td>
        <td>365 days</td>
      </tr>
      <tr>
        <td><a href="https://cookiepedia.co.uk/host/onetrust.com">onetrust.com</a></td>
        <td>__cfduid</td>
        <td>Third party</td>
        <td>30 days</td>
      </tr>
    </tbody>
  </table>
  <p style="font-weight: bold;">Managing cookies through browser configuration</p>
  <p class="addSpace">
    Although blocking cookies may result in the inability to enjoy certain features of the site you visit, you can
    also manage your cookie preferences through the settings of the browser used by your device.
  </p>
  <p>
    You can select the browser you use below for details on how to change these settings:
  </p>
  <ul style="list-style-type: none;">
    <li><span aria-hidden="true">•</span> <a href="https://support.mozilla.org/it/kb/Bloccare%20i%20cookie">Firefox</a></li>
    <li><span aria-hidden="true">•</span> <a href="https://support.microsoft.com/it-it/windows/eliminare-e-gestire-i-cookie-168dab11-0753-043d-7c16-ede5947fc64d#:~:text=Per%20eliminare%20i%20cookie,Web%20e%20quindi%20scegliere%20Elimina.">Internet Explorer</a></li>
    <li><span aria-hidden="true">•</span> <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09#:~:text=Apri%20Microsoft%20Edge%20and%20seleziona,del%20sito%2C%20quindi%20Cancella%20ora.">Edge</a></li>
    <li><span aria-hidden="true">•</span> <a href="https://support.google.com/chrome/answer/95647?hl=it&co=GENIE.Platform%3DAndroid">Google Chrome</a></li>
    <li><span aria-hidden="true">•</span> <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac">Safari</a></li>
  </ul>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">4)</span> To whom may your personal data be disclosed?</h6>
  <p class="addLessSpace">
    Your personal data may be known to the Company's personnel authorized to process them by reason of the performance
    of their work duties.
  </p>
  <p class="addLessSpace">
    In addition, the Company may disclose your personal data to third parties acting as Data Processors, specifically
    appointed pursuant to Article 28 of the Regulations, such as by way of example but not limited to service
    management companies and IT systems.
  </p>
  <p>
    Finally, your personal data may be shared with authorities and/or entities as well as with third-party
    cookie-holding companies operating as autonomous data controllers.
  </p>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">5)</span> Can your personal data be transferred to countries outside the European Economic Area?</h6>
  <p>
    The transfer of your personal data outside the European Economic Area will take place to third countries for which
    the European Commission has recognized that they provide an adequate level of protection or where there are
    adequate safeguards or the specific exceptions provided for in the Regulation.
  </p>
</div>
<div class="ques addSpace">
  <h6><span aria-hidden="true">6)</span> How long is your personal data kept?</h6>
  <p>
    The Company stores data in a form that allows the identification of data subjects for a period of time necessary
    to achieve the specific purposes for which they are processed, in compliance with contractual and/or regulatory
    obligations. The duration of individual cookies is specified in the table above.
  </p>
</div>
<div class="ques">
  <h6><span aria-hidden="true">7)</span> What are your rights?</h6>
  <p>
    We inform you that you, as a data subject, may exercise the following rights regarding the processing of your personal data:
  </p>
  <ol class="addSpace" style="list-style-type: none;">
    <li>
      <span aria-hidden="true">a.</span> right of access: right to obtain from the Data Controller confirmation as to
      whether or not any processing of your personal data is taking place, and if so, to obtain access to the same
      (provided that this does not infringe the rights of others);
    </li>
    <li>
      <span aria-hidden="true">b.</span> right to erasure ("oblivion"): right to obtain from the Data Controller
      the erasure of your personal data without undue delay. The Company has an obligation to proceed with such
      deletion if, but not limited to:
      <ol class="pl-4 py-2" style="list-style-type: none;">
        <li>
          <span aria-hidden="true">i.</span> Your personal data are no longer necessary with respect to the purpose
          of the processing;
        </li>
        <li>
          <span aria-hidden="true">ii.</span> Your personal data have been processed unlawfully;
        </li>
        <li>
          <span aria-hidden="true">iii.</span> Your personal data must be deleted in order to comply with a legal
          obligation;
        </li>
      </ol>
    </li>
    <li>
      <span aria-hidden="true">c.</span> Right to restriction of processing: right to obtain from the Data
      Controller the restriction of processing. The Company is obliged to proceed with the aforementioned restriction
      if:
      <ol class="pl-4 py-2" style="list-style-type: none;">
        <li>
          <span aria-hidden="true">i.</span> the accuracy of your personal data is disputed (for the period necessary
          for the Controller to verify the accuracy of such personal data);
        </li>
        <li>
          <span aria-hidden="true">ii.</span> the processing is unlawful and you have objected to the deletion of
          your personal data and requested its limitation;
        </li>
        <li>
          <span aria-hidden="true">iii.</span> the personal data (although no longer necessary for the purposes of
          processing) is needed by you for the establishment, exercise or defense of a legal claim;
        </li>
        <li>
          <span aria-hidden="true">iv.</span> checks are being made as to whether the interests of the Company
          prevail if you have exercised your right to object as set out below;
        </li>
      </ol>
    </li>
    <li>
      <span aria-hidden="true">d.</span> right to data portability: right to receive in a structured, commonly used
      and machine-readable format your personal data and to transmit such data to another Data Controller, only for
      cases where the processing is based on consent or contract and only for data processed by electronic means;
    </li>
    <li>
      <span aria-hidden="true">e.</span> Right to lodge a complaint with a Supervisory Authority: without prejudice
      to any other administrative or judicial remedy, if you believe that the processing concerning you is in
      violation of the Regulation, you have the right to lodge a complaint with the Supervisory Authority of the
      Member State in which you usually reside or work, or of the State where the alleged violation occurred.
    </li>
  </ol>
  <p>
    To exercise the above rights, you can submit a request to the following addresses:
  </p>
  <ul class="addLessSpace" style="list-style-type: none;">
    <li><span aria-hidden="true">-</span> mailing address: Piazza Gaudenzio Sella, No. 1, 13900, Biella;</li>
    <li><span aria-hidden="true">-</span> e-mail addresses: <a id="last0" href="mailto:privacy@centrico.tech">privacy@centrico.tech</a>;</li>
  </ul>
  <p>
    The Company will provide information regarding the action taken regarding the specific request without undue
    delay and at the latest within one month of its receipt.
  </p>
  <p>
    In any case, you can contact the Company and/or the DPO at the above-mentioned addresses should you wish to have
    more details and/or need clarifications with respect to the processing carried out on your personal data.
  </p>
  <p class="addSpace">
    Should the exercise of the rights listed above result in an actual and concrete prejudice to the interests protected under the
    provisions on money laundering, pursuant to Article 2-undecies Privacy Code, the scope of such rights and certain related
    obligations incumbent on the Data Controller may be limited. In such circumstances, the exercise of the same rights may be
    delayed, limited or excluded, for such time and to the extent that this constitutes a necessary and proportionate measure.
    If the conditions are met, a reasoned notice will be sent to you without delay.
  </p>
  <p style="text-align:end;">Last updated: 30/04/2024</p>
</div>`;

const legalModalHtml = `
<p class="btxt">> Any information on this website is the exclusive property of Centrico S.P.A. By
  using
  this website you agree to be bound and abide by the Terms and Conditions set hereunder. If you do
  not
  agree, the use of this website and download of any materials is not permitted.
  <br><br>
  Centrico S.P.A. allows the access to and use of any information displayed on this website only
  subject
  to the following conditions:
</p>
<p>
  > any content on this website shall be used for information purposes only; any upload, copy,
  reproduction, reuse, retransmission, distribution, republishing on any computer network, or
  disclosure
  in any form, or by any means, is not permitted. The use of documents displayed on this website for
  commercial or personal purposes is prohibited.</p>

<p>
  > modification of any document on this website is forbidden. Unauthorized use for whatever purpose
  is
  explicitly prohibited by law and implies for civil and criminal liability. Anyone found in violation
  of these provisions shall be prosecuted by all possible means.</p>
<br>

<p> Intellectual property rights shall be mentioned on all copies, together with the relevant
  authorization to use them.</p>
<br>
<p> Centrico S.P.A has no liability regarding the accuracy of information contained in the documents
  submitted by candidates/visitors through this website, whatever the purpose. Centrico S.P.A. shall
  not
  be liable under any circumstances for any direct, indirect, possible, private or any other type of
  civil damages (including, but not limited to, damages for loss of earnings, interruption of
  commercial
  activities or loss of commercial information), even in the event Centrico S.P.A. could be aware of
  such damages.</p>
<br>
<p> Centrico is a registered trademark of Centrico S.P.A. which is the sole owner of the Centrico
  trademark and logo. The use of the Centrico trademark and logo on any Internet site, other than this
  one is strictly prohibited.</p>
<br>
<p> This website uses cookies to offer its visitors a better browsing experience, and offer services
  more
  suited to their needs and interests.</p>
<br>
<p>For any information, please contact us at <a id="last1" href="mailto:info@centrico.tech">info@centrico.tech</a>
</p>
<br>
<p class="btxt">
  Applicable law and jurisdiction
</p>
<p>
  These Terms and Conditions are governed by Italian law; for any dispute that may arise with
  Centrico
  SpA, the competent Court is exclusively that of Biella. However, Centrico S.p.a. reserves the right
  to
  take legal action in countries or cities other than Italy and Biella, to protect its interests or to
  enforce its rights, whenever it deems it appropriate to do so.
</p>`;

export default function ModalFooter({ modalType, onHide }) {
  const modalTitle = modalType === 'cookie' ? 'Cookie Policy' : 'Legal Terms';

  return (
    <Modal show={Boolean(modalType)} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <div dangerouslySetInnerHTML={{ __html: modalType === 'cookie' ? cookieModalHtml : legalModalHtml }} />
      </Modal.Body>
    </Modal>
  );
}
